import { Component, OnInit, ViewChild } from "@angular/core";
import { BreadCrumbModel } from "app/views/campaign-3/models/campaign-3-breadcrumb.model";
import { ChallengeService } from "../challenge.service";
import { AcmChallenge, ChallengeResponse, SaveChallengeDto } from "../challenge.model";
import { ActivatedRoute, Router } from "@angular/router";
import { LoyaltyAcmService } from "app/services/loyalty/loyalty-acm.service";
import { Observable } from "rxjs";
import { DistributionList3 } from "app/views/campaign-3/models/campaign-3.model";
import { DistributionList3Service } from "app/views/distribution-list/services/distribution3.service";
import { Campaign3Service } from "app/views/campaign-3/services/campaign3.service";
import { MessageService } from "primeng/primeng";
import { ClusterHeadNewList } from "app/views/campaign-3/models/campaign-3-customer-target.model";
import { TranslateService } from "@ngx-translate/core";
import { FormFields } from "app/views/campaign-3/components/form-fields/form-fields.component";
import { ConfirmationService } from "primeng/api";
import { ChallengeTemplate } from "app/models/challenge-template";
import { Touchpoint } from "app/models/touch-point.model";
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import * as cloneDeep from 'lodash/cloneDeep';
import { DatePipe } from "@angular/common";
import { LoyaltyParamsService } from "app/services/loyalty/params.service";

export class OptionDropdown {
  label: string;
  value: number;

  constructor(label: string, value: number) {
    this.label = label;
    this.value = value;
  }
}

export interface ChallengeDetailTotalResponse {
  id: number;
  challenge: ChallengeEditResponse;
  challengeDetail: any[];
  challengeOchannel: ChallengeOchannelResponse[];
  challengeReward: any[];
}

export class ChallengeOchannelResponse {
  id: number;
  challengeId: number;
  ochannel: any;
  templateValue: any; // oppure any, se preferisci
}

export class ChallengeEditResponse {
  id: number | null = null;
  title: string | null = null;
  description: string | null = null;
  dateStart: string | null = null; // LocalDate -> string in TS (ISO yyyy-MM-dd)
  dateEnd: string | null = null;   // LocalDate -> string in TS
  flgAgreementRequired: string | null = null;
  conditionBooleanOperator: string | null = null;
  agreementClusterHead: any | null = null;
  distributionList: any | null = null;
  challengeType: any | null = null;
  template: any | null = null;
  flgPreview: string | null = null;
  flgPushNotification: string | null = null;
  dayOffset: number | null = null;
  timeOffset: string | null = null;
  pushNotificationText: string | null = null;
  priority: number | null = null;
  status: string | null = null;
  numLevel: number | null = null;
  templateValue: any | null = null;
  challengeStatus: any | null = null;
  layoutDefaultSchema: any | null = null;
  layoutDefaultValue: any | null = null;
}

@Component({
  selector: 'app-challenge-creation',
  templateUrl: './challenge-creation.component.html',
  styleUrls: ['./challenge-creation.component.css']
})
export class ChallengeCreationComponent implements OnInit {
  currentSchema: any;

  @ViewChild('titleField') titleField: FormFields;
  @ViewChild('descriptionField') descriptionField: FormFields;
  @ViewChild('kindField') kindField: FormFields;
  @ViewChild('dateStartField') dateStartField: FormFields;
  @ViewChild('dateEndField') dateEndField: FormFields;
  @ViewChild('priorityField') priorityField: FormFields;
  @ViewChild('flgAcceptanceField') flgAcceptanceField: FormFields;
  @ViewChild('acceptanceClusterField') acceptanceClusterField: FormFields;
  @ViewChild('templateField') templateField: FormFields;
  @ViewChild('pushNotify') pushNotify: FormFields;
  @ViewChild('pushNotifyText') pushNotifyText: FormFields;
  @ViewChild('dayBeforeNotifyPushField') dayBeforeNotifyPushField: FormFields;
  @ViewChild('notifyPushHourField') notifyPushHourField: FormFields;


  @ViewChild('listaDistribuzioneChallenge') listaDistribuzioneChallenge: FormFields;

  formData: any = {};
  form = new FormGroup({});
  fields: FormlyFieldConfig[];
  model = {}; //TODO DA GESTIRE IN CASO DI EDIT per i touchpoint

  fieldModel = {
    title: '',
    description: '',
    kind: null,
    dateStart: null as Date | null,
    dateEnd: null as Date | null,
    priority: null,
    flg_acceptance: null,
    acceptance_cluster: null,
    template: null,
    layoutDefaultSchema: null,
    layoutDefaultValue: null,
    pushNotify: false,
    pushNotifyText: '',
    dayBeforeNotifyPush: null,
    notifyPushHour: null

  };
  challengeTouchpointValid: boolean = true;
  currentTouchpointIndex: number | null = null;
  show = {
    modalAcmList: false,
    modalDistributionList: false,
    modalDistributionListDetails: false,
    modalClusterHeadNewList: false,
    modalLayoutTouchpoint: false,
    modalLayoutDefault: false,
    modalTemplate: false
  }


  //variabili per la lista
  combotype: any[] = []
  clusterOptions: any[];
  idSingleChallenge: any;
  listAccumulator: any;
  touchpointList: Touchpoint[] = [];
  selectedAcm: AcmChallenge[] = [];
  breadcrumbs: Array<BreadCrumbModel> = [];
  editMode: boolean = false;
  singleChallenge: ChallengeResponse;
  provTitle: string = ''
  currentDistributionListId: any;
  showTable = false;
  challengeId: number;
  distributionList: DistributionList3[] = [];
  clusterList: any[] = [];
  selectedDistributionList: DistributionList3
  useAnd: boolean = false;
  distributionListDetails: any[]
  idNewChallenge: number;
  templateDropdownList: OptionDropdown[] = [];
  templateList: ChallengeTemplate[] = [];
  selectedTemplate: ChallengeTemplate[] = [];
  selectedOptionType: OptionDropdown | null = null;
  selectedOptionTemplate: OptionDropdown | null = null;
  originalClusters: any[] = [];
  isPushNotificationEnabled: boolean = true;

  private previousTemplate: OptionDropdown | null = null;
  // templateOptionsDropdown: OptionDropdown[];
  templateSelected: ChallengeTemplate;
  constructor(
    private challengeService: ChallengeService,
    public router: Router,
    private srvLoyaltyAcm: LoyaltyAcmService,
    private distributionService: DistributionList3Service,
    private srvCampaign3: Campaign3Service,
    private srvNotify: MessageService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private srvConfirmation: ConfirmationService,
    private datePipe: DatePipe,
    private paramService: LoyaltyParamsService


  ) { }


  today: Date



  challengeData: ChallengeEditResponse;
  ochannelList: ChallengeOchannelResponse[];

  // ----------------- ngOnInit -----------------
  ngOnInit(): void {
    this.today = new Date();
    this.loadInitialData();
    this.initBreadCrumbs();
  }

  // ----------------- ComboType -----------------
  private initCombo(typeList): void {
    this.combotype.push({ label: '', value: null });

    if (typeList) {

      for (const challengeType of typeList) {
        this.combotype.push({ label: challengeType.description, value: challengeType.id });

      }
    }
  }

  // ----------------- Caricamento iniziale dati -----------------
  private loadInitialData(): void {
    const params = [{ key: 'limit', value: '9999999' }];

    Observable.zip(
      this.srvLoyaltyAcm.getAllAcm(),
      this.challengeService.getClusterHeadAllListWithParams(params),
      this.distributionService.list(),
      this.challengeService.getTouchPoints(),
      this.challengeService.getChallengeTypeList(),
      this.challengeService.getChallengeTemplateList(),
      this.paramService.getParamByKey('PUSH.NOTIFICATION.ENABLED')
    ).subscribe(([res_acc, res_clust, distrList, touchList, resType, templateList, pushParamRes]) => {
      if (pushParamRes) {
        this.isPushNotificationEnabled = (pushParamRes.param_code !== '0');
      } else {
        this.isPushNotificationEnabled = true;
      }

      this.handleAccumulatorResponse(res_acc);
      this.handleClusterResponse(res_clust);
      this.handleDistributionResponse(distrList);
      this.handleTouchpointResponse(touchList);
      this.initCombo(resType)
      this.handleTemplateResponse(templateList);

      this.evaluateEditMode();

      this.showTable = true;
    });
  }

  // ----------------- Handlers -----------------
  private handleAccumulatorResponse(res_acc: any): void {
    if (res_acc) {

      var filtered = [];

      for (var i = 0; i < res_acc.length; i++) {
        var acc = res_acc[i];

        var dEnd = acc.dateEnd ? new Date(acc.dateEnd) : null;

        // tieni accumulatori non scaduti
        if (!dEnd || dEnd >= this.today) {
          filtered.push(acc);
        }
      }

      this.listAccumulator = filtered;
    }
  }


  private handleClusterResponse(res_clust: any): void {
    if (res_clust) {

      this.originalClusters = res_clust.map(function (element) {
        return {
          clusterDescription: element.clusterDescription,
          clusterHeadId: element.clusterHeadId,
          startDate: element.date_start ? new Date(element.date_start) : null,
          endDate: element.date_end ? new Date(element.date_end) : null
        };
      });

      this.clusterList = this.buildClusterDisplayList(this.originalClusters);
    }
  }
  private buildClusterDisplayList(list: any[]): any[] {
    var result = [];

    // record vuoto SEMPRE
    result.push({ label: '', value: null });

    for (var i = 0; i < list.length; i++) {
      var c = list[i];

      var start = c.startDate ? this.formatDate(c.startDate) : '';
      var end = c.endDate ? this.formatDate(c.endDate) : '';

      var dateRange = '';
      if (start && end) dateRange = ' [' + start + ' - ' + end + ']';
      else if (start) dateRange = ' [' + start + ']';

      result.push({
        label: c.clusterDescription + dateRange,
        value: c.clusterHeadId
      });
    }

    return result;
  }
  private formatDate(date: Date): string {
    let result = '';

    if (date) {
      const transformed = this.datePipe.transform(date, 'yyyy-MM-dd');
      if (transformed !== null) {
        result = transformed;
      }
    }

    return result;
  }




  private handleDistributionResponse(distrList: any): void {
    if (distrList) {
      this.distributionList = distrList.data;
    }
  }

  private handleTouchpointResponse(touchList: any): void {
    if (touchList) {
      this.touchpointList = touchList.map((t: any) => ({
        ...t,
        active: false
      }));
      this.touchpointList = this.touchpointList.filter(x => x.flg_offline != '1');
    }
  }
  private handleTemplateResponse(templateList: any): void {
    if (templateList) {
      this.templateDropdownList = templateList.map((t: any) => ({
        label: t.code + ' - ' + t.description,
        value: t.id
      }));
      this.templateList = templateList;
    }
  }
  // ----------------- Modalità edit -----------------
  private evaluateEditMode(): void {
    const idParam = this.route.snapshot.queryParamMap.get('challengeId');
    if (!idParam) {
      this.editMode = false;
      return;
    }

    this.editMode = true;
    this.challengeId = Number(idParam);

    this.challengeService.getChallengeDataForEdit(this.challengeId)
      .subscribe(res => this.handleEditData(res));
  }
  challengeStatus = null;
  // ----------------- Popolamento dati edit -----------------
  private handleEditData(res: any): void {
    const challenge: ChallengeEditResponse = res.challenge as ChallengeEditResponse;
    const ochannels = res.challengeOchannel as ChallengeOchannelResponse[];
    /*     const acmResponse: any[] = res.challengeReward as any[];
     */      const acmResponse: any[] = res.challengeAcm as any[];

    console.log(challenge.status)


    const templateResponse: any[] = res.challengeTemplate as any[];
    this.initBaseFields(challenge);
    this.initTouchpoint(ochannels);
    this.initAcm(acmResponse);
    this.initDistributionListSection(challenge);

    this.initTemplate(templateResponse);
    this.fieldModel.layoutDefaultSchema = challenge.template.templateSchema;
    this.fieldModel.layoutDefaultValue = challenge.templateValue;
    this.model = this.fieldModel.layoutDefaultValue;

    // 🔹 Valutazione readOnly
    this.evaluateReadOnly(challenge);
    console.log(this.readOnly);
    console.log('FieldModel inizializzato (EDIT):', this.fieldModel);
  }
  readOnly: boolean = false;

  private evaluateReadOnly(challenge: ChallengeEditResponse): void {
    let readOnly = false;

    // Caso sicurezza: se challenge è null → readonly
    if (!challenge) {
      readOnly = true;
    } else {
      const status = challenge.status ? Number(challenge.status) : null;
      const dateStart = challenge.dateStart ? new Date(challenge.dateStart) : null;
      const now = new Date();

      // 1. Stato 0 → Pubblicata → sempre readonly
      if (status === 0) {
        readOnly = true;

        // 2. Stato 4 → Pubblicazione annullata
      } else if (status === 4) {

        if (dateStart) {
          // Se la challenge è già iniziata → readonly
          if (now >= dateStart) {
            readOnly = true;
          } else {
            // Non è ancora iniziata → si può modificare
            readOnly = false;
          }
        } else {
          // Se manca la data, per sicurezza → readonly = true
          readOnly = true;
        }

        // 3. Tutti gli altri stati → modificabile
      } else {
        readOnly = false;
      }
    }

    this.readOnly = readOnly;
  }





  // ----------------- Inizializzazione Base Fields -----------------
  private initBaseFields(challenge: ChallengeEditResponse): void {
    let selectedKind = null;
    if (challenge.challengeType) {
      selectedKind = this.combotype.find(k => k.value === challenge.challengeType.id) || null;
    }
    console.log({ selectedKind });

    let selectedTemplateOption = null;
    if (challenge.template) {
      selectedTemplateOption = this.templateDropdownList.find(k => k.value === challenge.template.id) || null;
      this.templateSelected = this.templateList.find(t => t.id === selectedTemplateOption.value);
      console.log({ selectedTemplate: selectedTemplateOption });
    }

    let selectedCluster = null;
    if (challenge.agreementClusterHead) {
      selectedCluster = this.clusterList.find(
        c => c.value === challenge.agreementClusterHead.id
      ) || null;

      if (!selectedCluster) {
        console.warn(
          '[Cluster] Nessun cluster trovato per agreementClusterHead.id:',
          challenge.agreementClusterHead.id,
          'clusterList:',
          this.clusterList
        );
      }
    }
    this.challengeStatus = challenge.status;
    //TODO controllare il tempo
    this.fieldModel = {
      title: challenge.title || '',
      description: challenge.description || '',
      kind: selectedKind,
      dateStart: challenge.dateStart ? new Date(challenge.dateStart) : null,
      dateEnd: challenge.dateEnd ? new Date(challenge.dateEnd) : null,
      priority: (challenge.priority !== undefined && challenge.priority !== null)
        ? challenge.priority
        : null,
      flg_acceptance: challenge.flgAgreementRequired === '1',
      acceptance_cluster: selectedCluster,
      template: selectedTemplateOption || null,
      layoutDefaultSchema: challenge.template.templateSchema,
      layoutDefaultValue: challenge.templateValue,
      pushNotify: challenge.flgPushNotification === '1',
      pushNotifyText: challenge.pushNotificationText || null,
      dayBeforeNotifyPush: challenge.dayOffset || null,
      notifyPushHour: challenge.timeOffset || null
    };
    this.useAnd = challenge.conditionBooleanOperator === "AND" ? true : false;

    this.previousTemplate = this.fieldModel.template;
    this.handleSelectType(selectedKind);
  }

  // ----------------- Inizializzazione Touchpoint -----------------
  private initTouchpoint(challengeOchannels: ChallengeOchannelResponse[]): void {
    if (!challengeOchannels || challengeOchannels.length === 0) {
      console.warn('challengeOchannels vuoto o nullo, nessuna inizializzazione touchpoint.');
      return;
    }

    challengeOchannels.forEach(incomingTp => {

      if (!incomingTp || !incomingTp.ochannel) return;

      const existingTp = this.touchpointList.find(t => t.id === incomingTp.ochannel.id);

      if (existingTp) {
        existingTp.challengeOchannelsId = incomingTp.id;
        existingTp.active = true;
        existingTp.templateValue = cloneDeep(incomingTp.templateValue);
      }
    });

    this.checkForTouchpointPriority();
    // TODO: funzione per layout touchpoint
  }

// Helper per applicare il flag "cancellato" alla distribution list


  // Helper per applicare il flag "cancellato" alla distribution list
  private applyDeletedFlagToDistributionList(dl: any): void {
    if (dl && dl.flg_state === "1") {
      dl.distributionListName = dl.distributionListName + ' (' + this.translate.instant('challenge.deleted_female') + ')';
    }}


  // ----------------- Inizializzazione Distribution List -----------------
  private initDistributionListSection(challenge: ChallengeEditResponse): void {
    let tempSelected = null;

    if (this.distributionList && challenge && challenge.distributionList) {
      tempSelected = this.distributionList.find(dl =>
        dl && dl.distributionListId === challenge.distributionList.id
      );

      // Se non trovata, cercare via service (lista eliminata ma usata nella challenge)
      if (!tempSelected && challenge.distributionList.id) {
        this.srvCampaign3.getDistributionListById(challenge.distributionList.id).subscribe(
          (result: any) => {
            const dl = Array.isArray(result) ? result[0] : result;

            if (dl) {
              this.applyDeletedFlagToDistributionList(dl);
              this.distributionList = [...this.distributionList, dl];
              this.selectedDistributionList = dl;
            } else {
              this.selectedDistributionList = null;
            }
            console.log('Distribution list recuperata dal service:', this.selectedDistributionList);
          },
          error => {
            console.error('Errore nel recuperare la distribution list:', error);
            this.selectedDistributionList = null;
    }
        );
      } else {
        this.applyDeletedFlagToDistributionList(tempSelected);
    this.selectedDistributionList = tempSelected ? tempSelected : null;

    console.log(this.selectedDistributionList);
      }
    } else {
      this.selectedDistributionList = null;
      console.log(this.selectedDistributionList);
    }
  }


  // ----------------- Inizializzazione ACM -----------------
  /**
   * Inizializza gli accumulatori selezionati dalla response,
   * evitando duplicati
   */
  private initAcm(acmResponse: any[]): void {
    if (!acmResponse || acmResponse.length === 0 || !this.listAccumulator) {
      this.selectedAcm = [];
      // resetta rowSelected nella lista originale
      this.listAccumulator.forEach(acc => acc.rowSelected = false);
      return;
    }

    const addedAcmIds = new Set<number>();
    this.selectedAcm = [];

    // prima resetta tutte le righe
    this.listAccumulator.forEach(acc => acc.rowSelected = false);

    for (let i = 0; i < acmResponse.length; i++) {
      const acmId = acmResponse[i].acmId;
      const acmItemId = acmResponse[i].id;

      if (!acmId || !acmId.id) {
        continue;
      }

      if (addedAcmIds.has(acmId.id)) {
        continue;
      }

      const foundAccumulator = this.listAccumulator.find(
        acc => acc && acc.id === acmId.id
      );

      if (foundAccumulator) {
        // segniamo la riga come selezionata
        foundAccumulator.rowSelected = true;

        // aggiungiamo all'array dei selezionati (clonando se vuoi mantenere l'id extra)
        const enrichedAccumulator = {
          ...foundAccumulator,
          acmChallengeId: acmItemId
        };

        this.selectedAcm.push(enrichedAccumulator);
        addedAcmIds.add(acmId.id);
      }
    }

    console.log('Selected ACMS (with rowSelected in listAccumulator):', this.selectedAcm);
  }


  private initBreadCrumbs(): void {
    this.translate.get([
      'challenge.challenge-list',
      'challenge.createEdit'
    ]).subscribe(translations => {

      this.breadcrumbs = [];

      const breadcrumb1 = new BreadCrumbModel();
      breadcrumb1.code = 'bc1';
      breadcrumb1.description = translations['challenge.challenge-list'];
      breadcrumb1.routerLink = '/challenge-list';

      const breadcrumb2 = new BreadCrumbModel();
      breadcrumb2.code = 'bc2';
      breadcrumb2.description = translations['challenge.createEdit'];
      breadcrumb2.routerLink = '/challenge-creation';

      this.breadcrumbs.push(breadcrumb1, breadcrumb2);
    });
  }


  /*   onBackAction(): void {
      this.router.navigate(['/challenge-list']);
    } */

  onBackAction(): void {
    this.router.navigate(['/challenge-list'], {
      queryParams: { challengeId: this.challengeId }
    });
  }

  //valido prima di salvare
  onSaveChallenge(): void {
    if (this.performFieldValidation()) {

      this.saveOrEditChallenge();
    } else {
      console.log("ci sono errorei nella validazione")
    }

  }
  //filtro i dati del template a seconda del tipo di sfida selezionato
  handleSelectType(event: any) {
    this.selectedOptionType = event;

    // 🔹 controllo che event sia valido
    if (!event || event.value == null) {
      // Reset liste
      this.templateDropdownList.splice(0);
      this.templateList.splice(0);

      // Reset dei campi
      this.fieldModel.template = null;
      this.fieldModel.kind = null;

      // Notifica di errore
      this.srvNotify.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('challenge.type_not_found')
      });

      return; // esco subito
    }

    const typeIdSelected = event.value;

    // Reset liste
    this.templateDropdownList.splice(0);
    this.templateList.splice(0);

    // Carico template filtrati
    this.challengeService
      .getChallengeTemplateList(typeIdSelected)
      .subscribe(response => {
        const filtered = response.filter(t => t.challengeTypeId === typeIdSelected);
        this.templateList.push(...filtered);
        this.handleTemplateResponse(this.templateList);
      });
  }






  //REFGF validazione senza queryfield
  //Valido il fieldmodel
  /*  performFieldValidation(): void {
     const fields = [
       { ref: this.titleField, name: 'title' },
       { ref: this.descriptionField, name: 'description' },
       { ref: this.kindField, name: 'kind' },
       { ref: this.dateStartField, name: 'dateStart' },
       { ref: this.dateEndField, name: 'dateEnd' },
       { ref: this.priorityField, name: 'priority' },
       { ref: this.flgAcceptanceField, name: 'flg_acceptance' },
       { ref: this.acceptanceClusterField, name: 'acceptance_cluster' },
       { ref: this.templateField, name: 'template' },
       { ref: this.pushNotify, name: 'pushNotify' },
       { ref: this.pushNotifyText, name: 'pushNotifyText' }

     ];

     let allValidFormValues = true;

     // Validazione singoli campi
     fields.forEach(field => {
       if (field.ref && field.ref.performValidation) {
         field.ref.performValidation();
         if (!field.ref.valid) {
           allValidFormValues = false;
           console.error(`Errore nel campo ${field.name}: ${field.ref.errorMessage}`);
         }
       }
     });

     // VALIDAZIONE DATE
     if (
       this.dateStartField &&
       this.dateStartField.fieldModel
     ) {
       const startDate = new Date(this.dateStartField.fieldModel);

       if (this.dateEndField && this.dateEndField.fieldModel) {
         // date_end valorizzata → controllo coerenza
         const endDate = new Date(this.dateEndField.fieldModel);

         if (endDate < startDate) {
           allValidFormValues = false;
           this.dateEndField.valid = false;
           this.dateEndField.errorMessage = 'End date cannot be before start date';
           console.error(`Errore nel campo dateEnd: ${this.dateEndField.errorMessage}`);
         }
       }
     }
     //valido la parte delle distribution
     let allValidDistributionList = this.performValidationOnDistributionList();
     //Valido la parte dei touchpoint
     let allValidTouchpoint = this.performValidationOnTouchpoint();
     //Validazione ACm
     let allValidAcm = this.performValidationOnAcm();

     console.log({ allValidTouchpoint });
     if (allValidFormValues && allValidDistributionList && allValidTouchpoint && allValidAcm) {
       console.log('Tutti i campi sono validi. Salvataggio in corso...');
       const payload: SaveChallengeDto = {
         title: this.fieldModel.title,
         description: this.fieldModel.description,
         date_start: this.fieldModel.dateStart
           ? this.fieldModel.dateStart.toISOString().split('T')[0]
           : '',
         date_end: this.fieldModel.dateEnd
           ? this.fieldModel.dateEnd.toISOString().split('T')[0]
           : null,
         flg_agreement_required: this.fieldModel.flg_acceptance ? '1' : '0',
         condition_boolean_operator: this.useAnd ? 'AND' : 'OR',
         agreement_cluster_head_id: this.fieldModel.acceptance_cluster
           ? this.fieldModel.acceptance_cluster.value
           : null,
         distribution_list_id: this.selectedDistributionList
           ? this.selectedDistributionList.distributionListId
           : null,
         challenge_type_id: this.fieldModel.kind.value ? this.fieldModel.kind.value : 0,
         template_id: this.fieldModel.template.value,
         flg_preview: '0',                // placeholder per ora
         flg_push_notification: this.fieldModel.pushNotify ? '1' : '0',
         day_offset: this.fieldModel.dayBeforeNotifyPush ? this.fieldModel.dayBeforeNotifyPush : null,                // placeholder
         time_offset: this.fieldModel.notifyPushHour || null,
         push_notification_text: this.fieldModel.pushNotifyText || '',
         priority: this.fieldModel.priority ? Number(this.fieldModel.priority) : null,
         status: (this.challengeStatus == null) ? '2' : this.challengeStatus,                     // stato default
         template_value: this.fieldModel.layoutDefaultValue
       };
       if (this.editMode) {
         // 🔹 Modalità modifica
         this.challengeService.editChallenge(payload, this.challengeId).subscribe({
           next: (res: ChallengeResponse) => {
             console.log('Challenge aggiornata con successo:', res);
             console.log('ID Challenge:', res.id);

             this.idNewChallenge = null;

             // estrai e converti gli id degli ACM selezionati in numeri
             const acmIds = this.selectedAcm
               .filter(a => a && a.id !== null && a.id !== undefined)
               .map(a => parseInt(a.id, 10));

             if (acmIds.length > 0) {
               //TODO
               this.challengeService.saveChallengeAcm(this.challengeId, acmIds).subscribe({
                 next: acmRes => {
                   console.log('ChallengeAcm salvati correttamente:', acmRes);

                   //  PREPARA PAYLOAD TOUCHPOINT
                   const payloadTouchpoint = {
                     challenge_id: this.challengeId,
                     ochannels: this.touchpointList
                       .filter(tp => tp.active)
                       .map(tp => ({
                         id: tp.challengeOchannelsId ? tp.challengeOchannelsId : null,
                         ochannel: { id: tp.id },
                         template_value: tp.templateValue
                       }))
                   };

                   console.log('Payload Ochannels:', payloadTouchpoint);

                   //  SALVA TOUCHPOINT
                   //TODO
                   this.challengeService.saveChallengeOchannels(payloadTouchpoint).subscribe({
                     next: ochannelRes => {
                       console.log('ChallengeOchannel salvato correttamente:', ochannelRes);
                       this.srvNotify.add({
                         severity: 'success',
                         summary: this.translate.instant('common.success'),
                         detail: this.translate.instant('challenge.challengeUpdated')
                       });
                       // this.router.navigate(['/challenge-list']);
                     },
                     error: err => {
                       console.error('Errore nel salvataggio del ChallengeOchannel:', err);
                     }
                   });
                 },
                 error: err => console.error('Errore nel salvataggio dei ChallengeAcm', err)
               });
               this.router.navigate(['/challenge-list']);
             } else {
               console.log('Nessun ACM selezionato, skip salvataggio.');
             }
           },
           error: err => console.error('Errore nella modifica della challenge', err)
         });

       } else {

         // 🔹 Modalità creazione
         this.challengeService.createChallenge(payload).subscribe({
           next: (res: ChallengeResponse) => {
             console.log('Challenge creata con successo:', res);
             console.log('ID Challenge:', res.id);

             this.idNewChallenge = res.id;

             // estrai e converti gli id degli ACM selezionati in numeri
             const acmIds = this.selectedAcm
               .filter(a => a && a.id !== null && a.id !== undefined)
               .map(a => parseInt(a.id, 10));

             if (acmIds.length > 0) {
               this.challengeService.saveChallengeAcm(res.id, acmIds).subscribe({
                 next: acmRes => {
                   console.log('ChallengeAcm salvati correttamente:', acmRes);
                   const payloadTouchpoint = {
                     challenge_id: this.idNewChallenge,
                     ochannels: this.touchpointList
                       .filter(tp => tp.active)
                       .map(tp => ({
                         id: tp.challengeOchannelsId ? tp.challengeOchannelsId : null,
                         ochannel: { id: tp.id },
                         template_value: tp.templateValue
                       }))
                   };

                   console.log('Payload Ochannels:', payloadTouchpoint);

                   this.challengeService.saveChallengeOchannels(payloadTouchpoint).subscribe({
                     next: ochannelRes => {
                       console.log('ChallengeOchannel salvato correttamente:', ochannelRes);
                       this.srvNotify.add({
                         severity: 'success',
                         summary: this.translate.instant('common.success'),
                         detail: this.translate.instant('challenge.challengeCreated')
                       });
                       this.router.navigate(['/challenge-list']);

                     },
                     error: err => {
                       console.error('Errore nel salvataggio del ChallengeOchannel:', err);
                     }
                   });
                 },

                 error: err => {
                   console.error('Errore nel salvataggio dei ChallengeAcm:', err);
                 }
               });

             } else {
               console.log('Nessun ACM selezionato, skip salvataggio.');
             }
           },
           error: err => console.error('Errore nella creazione della challenge', err)
         });
       }


     } else {
       console.error('Errore nella validazione. Verifica i campi evidenziati.');
     }
   }



   saveOrEditChallenge(){

   } */



  //validazione campi
  performFieldValidation(): boolean {
    const fields = [
      { ref: this.titleField, name: 'title' },
      { ref: this.descriptionField, name: 'description' },
      { ref: this.kindField, name: 'kind' },
      { ref: this.dateStartField, name: 'dateStart' },
      { ref: this.dateEndField, name: 'dateEnd' },
      { ref: this.priorityField, name: 'priority' },
      { ref: this.flgAcceptanceField, name: 'flg_acceptance' },
      { ref: this.acceptanceClusterField, name: 'acceptance_cluster' },
      { ref: this.templateField, name: 'template' }
    ];
    if (this.isPushNotificationEnabled) {
      fields.push(
        { ref: this.pushNotify, name: 'pushNotify' },
        { ref: this.pushNotifyText, name: 'pushNotifyText' }
      );
    }

    let allValid = true;

    // Validazione singoli campi
    fields.forEach(field => {
      if (field.ref && field.ref.performValidation) {
        field.ref.performValidation();
        if (!field.ref.valid) {
          allValid = false;
          console.error(`Errore nel campo ${field.name}: ${field.ref.errorMessage}`);
        }
      }
    });

    // Validazione date
    if (this.dateStartField && this.dateStartField.fieldModel &&
      this.dateEndField && this.dateEndField.fieldModel) {
      const startDate = new Date(this.dateStartField.fieldModel);
      const endDate = new Date(this.dateEndField.fieldModel);
      if (endDate < startDate) {
        allValid = false;
        this.dateEndField.valid = false;
        this.dateEndField.errorMessage = 'End date cannot be before start date';
        console.error(`Errore nel campo dateEnd: ${this.dateEndField.errorMessage}`);
      }
    }

    // Validazioni liste
    allValid = allValid && this.performValidationOnDistributionList();
    allValid = allValid && this.performValidationOnTouchpoint();
    allValid = allValid && this.performValidationOnAcm();

    if (!allValid) {
      console.error('Errore nella validazione. Verifica i campi evidenziati.');
    }

    return allValid;

  }


  saveOrEditChallenge(): void {

    // ----------------------------------------------------
    //  BASE PAYLOAD (comune a CREATE e EDIT)
    // ----------------------------------------------------
    const basePayload: any = {

      challenge: {
        title: this.fieldModel.title,
        description: this.fieldModel.description,

        date_start: this.fieldModel.dateStart
          ? this.formatDate(this.fieldModel.dateStart)
          : '',

        date_end: this.fieldModel.dateEnd
          ? this.formatDate(this.fieldModel.dateEnd)
          : null,

        flg_agreement_required: this.fieldModel.flg_acceptance ? '1' : '0',

        condition_boolean_operator: this.useAnd ? 'AND' : 'OR',

        agreement_cluster_head_id:
          this.fieldModel.acceptance_cluster
            ? this.fieldModel.acceptance_cluster.value
            : null,

        distribution_list_id:
          this.selectedDistributionList
            ? this.selectedDistributionList.distributionListId
            : null,

        challenge_type_id:
          this.fieldModel.kind && this.fieldModel.kind.value
            ? this.fieldModel.kind.value
            : 0,

        template_id: this.fieldModel.template.value,
        flg_preview: '0',
        flg_push_notification: this.fieldModel.pushNotify ? '1' : '0',

        day_offset:
          this.fieldModel.dayBeforeNotifyPush
            ? this.fieldModel.dayBeforeNotifyPush
            : null,

        time_offset:
          this.fieldModel.notifyPushHour
            ? this.fieldModel.notifyPushHour
            : null,

        push_notification_text:
          this.fieldModel.pushNotifyText
            ? this.fieldModel.pushNotifyText
            : '',

        priority:
          this.fieldModel.priority
            ? Number(this.fieldModel.priority)
            : null,

        status: this.challengeStatus == null ? '2' : this.challengeStatus,

        template_value: this.fieldModel.layoutDefaultValue
      }
    };

    // ----------------------------------------------------
    //  COSTRUZIONE PAYLOAD COMPLETO (differente per CREATE / EDIT)
    // ----------------------------------------------------
    let fullPayload: any = {};

    if (this.editMode) {

      // ----------------------------------------------------
      //  🔥 EDIT MODE: include acmChallengeId + challengeOchannelsId
      // ----------------------------------------------------
      fullPayload = {

        ...basePayload,

        challengeAcmList: this.selectedAcm
          .filter(a => a && a.id != null)
          .map(a => ({
            acm_id: parseInt(a.id, 10),
            id: a.acmChallengeId    // <-- aggiunto
          })),

        challengeOchannelList: this.touchpointList
          .filter(tp => tp && tp.active)
          .map(tp => {
            const ochannelItem: any = {
              ochannel_id: tp.id,
              id: tp.challengeOchannelsId // <-- aggiunto
            };

            if (tp.templateValue)
              ochannelItem.template_value = tp.templateValue;

            return ochannelItem;
          })
      };

    } else {

      // ----------------------------------------------------
      //  🆕 CREATE MODE: payload semplice, come da BE
      // ----------------------------------------------------
      fullPayload = {

        ...basePayload,

        challengeAcmList: this.selectedAcm
          .filter(a => a && a.id != null)
          .map(a => ({
            acm_id: parseInt(a.id, 10)
          })),

        challengeOchannelList: this.touchpointList
          .filter(tp => tp && tp.active)
          .map(tp => {
            const ochannelItem: any = {
              ochannel_id: tp.id,
              id: tp.challengeOchannelsId // <-- aggiunto
            };

            if (tp.templateValue)
              ochannelItem.template_value = tp.templateValue;

            return ochannelItem;
          })
      };
    }

    // ----------------------------------------------------
    //  CHIAMATE HTTP → EDIT / CREATE
    // ----------------------------------------------------
    if (this.editMode) {

      this.challengeService.editFullChallenge(this.challengeId, fullPayload).subscribe({
        next: res => {

          this.srvNotify.add({
            severity: 'success',
            summary: this.translate.instant('common.success'),
            detail: this.translate.instant('challenge.challengeUpdated')
          });

          this.router.navigate(['/challenge-list'], {
            queryParams: { challengeId: res.id }
          });
        },
        error: err => console.error('Errore nella modifica della challenge', err)
      });

    } else {

      this.challengeService.createFullChallenge(fullPayload).subscribe({
        next: res => {

          this.srvNotify.add({
            severity: 'success',
            summary: this.translate.instant('common.success'),
            detail: this.translate.instant('challenge.challengeCreated')
          });

          this.router.navigate(['/challenge-list'], {
            queryParams: { challengeId: res.id }
          });
        },
        error: err => console.error('Errore nella creazione della challenge', err)
      });
    }
  }




  //Validazione ACM

  private performValidationOnAcm(): boolean {
    let isValid = true;

    const acmIds = this.selectedAcm
      .filter(a => a && a.id != null)
      .map(a => parseInt(a.id, 10));

    if (acmIds.length === 0) {
      this.srvNotify.add({
        severity: 'error',
        summary: 'Warning',
        detail: this.translate.instant('challenge.no_acm_selected')
      });

      console.warn('Nessun ACM selezionato.');
      isValid = false;
    }

    return isValid;
  }




  //todo validazione dei touchpoint
  // Validazione dei touchpoint con unico return + messaggio
  performValidationOnTouchpoint(): boolean {
    let isValid = false;
    this.challengeTouchpointValid = false;

    for (let tp of this.touchpointList) {

      if (tp.active) {

        // Touchpoint valido se ha templateValue o se esiste un layout default
        if (tp.templateValue || this.fieldModel.layoutDefaultValue) {
          tp.valid = true;
          isValid = true;
          break;
        } else {
          tp.valid = false;
        }

      } else {
        tp.valid = false;
      }
    }
    if (!isValid) {
      this.srvNotify.add({
        severity: 'warn',
        summary: this.translate.instant('common.warning'),
        detail: this.translate.instant('challenge.no_touchpoint_selected')
      });

      console.warn('Nessun touchpoint valido selezionato.');
    }

    return isValid;
  }

  performValidationOnDistributionList(): boolean {
    // Se il componente non è presente lo consideriamo non valido
    if (!this.listaDistribuzioneChallenge) {
      console.error('listaDistribuzioneChallenge non trovato.');
      return false;
    }

    // Se esiste la funzione performValidation → eseguila
    if (this.listaDistribuzioneChallenge.performValidation) {
      this.listaDistribuzioneChallenge.performValidation();

      if (!this.listaDistribuzioneChallenge.valid) {
        console.error(
          `Errore nel campo listaDistribuzioneChallenge: ${this.listaDistribuzioneChallenge.errorMessage}`
        );
        return false;
      }
    } else {
      // Nessuna funzione di validazione: fallback
      console.warn('performValidation() non presente su listaDistribuzioneChallenge.');
    }

    // Controllo logico: dev’esserci una lista selezionata
    if (
      this.selectedDistributionList === null ||
      this.selectedDistributionList === undefined
    ) {
      this.listaDistribuzioneChallenge.valid = false;
      this.listaDistribuzioneChallenge.errorMessage = 'Distribution list required';

      console.error(
        `Errore listaDistribuzioneChallenge: ${this.listaDistribuzioneChallenge.errorMessage}`
      );
      return false;
    }

    return true;
  }



  goToChallengeList() {
    this.router.navigate(["/challenge-list"])
  }

  onAddAccumulator() {
    this.show.modalAcmList = !this.show.modalAcmList;
  }

  onAcmSelected(listAcm: Array<any>) {
    // Se lista nulla → azzero tutto
    if (!listAcm) {
      this.selectedAcm = [];
      this.show.modalAcmList = false;
      return;
    }

    // 1. Rimuovo gli ACM che non sono più nella lista passata
    this.selectedAcm = this.selectedAcm.filter(function (sel) {
      return listAcm.some(function (item) {
        return item.id === sel.id;
      });
    });

    // 2. Aggiungo gli ACM nuovi
    listAcm.forEach(function (acm) {
      var exists = this.selectedAcm.some(function (sel) {
        return sel.id === acm.id;
      });

      if (!exists) {
        this.selectedAcm.push(acm);
      }
    }, this);

    this.show.modalAcmList = false;
  }

  removeAccumulator(index: number) {
    if (index > -1) {
      const removed = this.selectedAcm[index];

      // 1️⃣ Aggiorna lo stato nella lista principale
      const itemInMainList = this.listAccumulator.find(acm => acm.id === removed.id);
      if (itemInMainList) {
        itemInMainList.rowSelected = false;
      }

      // 2️⃣ Rimuovi l'elemento dalla lista selezionata
      this.selectedAcm.splice(index, 1);
    }
  }



  onClickSearchListaDistribuzione() {

    this.show.modalDistributionList = true;

  }

  onClickAnnulla_ModalListDistribuzione() {
    this.show.modalDistributionList = false;
  }
  onDistributionListSelected(distList: DistributionList3) {
    this.selectedDistributionList = distList;
    this.show.modalDistributionList = false;
  }


  onClickAnnulla_ModalListDistribuzioneDetails() {
    this.show.modalDistributionListDetails = false;
  }

  onClickVisualizzaContenutoListaEmissione() {

    if (this.selectedDistributionList && this.selectedDistributionList.distributionListId) {
      this.provTitle = "Contenuto Lista " + this.selectedDistributionList.distributionListName;
      this.currentDistributionListId = this.selectedDistributionList.distributionListId;
      var self = this;
      this.challengeService.getDistributionListDetailsForChallenge(this.currentDistributionListId).subscribe(res => {
        if (res && res.data.length > 0) {
          self.distributionListDetails = res.data;
          self.show.modalDistributionListDetails = true;
        }
        else {
          self.srvNotify.add({
            severity: 'warn',
            summary: this.translate.instant('common.warning'),
            detail: this.translate.instant('challenge.no_detail_to_visualize')
          });
        }
      });

    }
    else {
      this.provTitle = "Contenuto Lista";
    }
  }

  clusterHeadNewList: Array<ClusterHeadNewList> = [];

  resetSelectedClusterHeads() {
    for (let ce of this.clusterHeadNewList) {
      ce["rowSelected"] = false;
    }
  }

  onClickCreaNuovaLista() {
    var self = this;
    if (!this.fieldModel.dateStart || !this.fieldModel.dateEnd) {
      this.srvNotify.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('challenge.challenge_dates_required_for_list')
      });
      return;
    }
    var sfidaStart = this.startOfDay(this.fieldModel.dateStart);
    var sfidaEnd = this.endOfDay(this.fieldModel.dateEnd);
    this.resetSelectedClusterHeads();
    this.srvCampaign3.getClusterHeadNewList().subscribe(res => {
      var inPeriod = (res || []).filter(function (ch) {
        if (!ch.date_start || !ch.date_end) {
          return false;
        }
        // il cluster deve COPRIRE tutto il periodo della sfida, non starci dentro
        return self.startOfDay(new Date(ch.date_start)) <= sfidaStart
          && self.endOfDay(new Date(ch.date_end)) >= sfidaEnd;
      });
      if (inPeriod.length > 0) {
        self.clusterHeadNewList = inPeriod;
        self.show.modalClusterHeadNewList = true;
      }
      else {
        self.srvNotify.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('challenge.no_cluster_to_visualize')
        });
      }
    })
  }
  newList = 'Create New List'
  onAnnullaClusterHead(toClose: boolean) {
    if (toClose) {
      this.show.modalClusterHeadNewList = false;
    }
  }
  onAggiungiClusterHead(modalData: { name: string, arrayClusterHeads: Array<ClusterHeadNewList> }) {
    //attivo la copia come emissione
    var self = this;
    if (modalData.name && modalData.name.length > 0 && modalData.arrayClusterHeads && modalData.arrayClusterHeads.length > 0) {
      this.srvCampaign3.createDistributionList(modalData.name).subscribe(res => {
        if (res) {
          if (res && res.id) {
            let arrayId: Array<number> = [];
            for (let ch of modalData.arrayClusterHeads) {
              arrayId.push(ch.clusterHeadId);
            }
            var self2 = self;
            self.srvCampaign3.addClusterHeadList(res.id, arrayId).subscribe(res2 => {
              if (res2) {
                self2.reloadComboLists();
              }
              else {
                self2.srvNotify.add({
                  severity: 'error',
                  summary: 'Warning',
                  detail: this.translate.instant('challenge.unable_to_create_distribution_list')
                });
              }
              self2.show.modalClusterHeadNewList = false;
            })
          }
        }
        else {
          self.srvNotify.add({
            severity: 'error',
            summary: 'Warning', // Mantieni in inglese
            detail: this.translate.instant('challenge.unable_to_create_distribution_list')
          });


        }
      });
    }
    // this.show.modalClusterHeadNewList = false;
  }


  reloadComboLists() {
    var self = this;
    this.distributionList = null;

    const DISTR_LIST = this.distributionService.list();
    DISTR_LIST.subscribe(res => {
      self.distributionList = res.data;
    })

  }





  checkForTouchpointPriority() {
    this.touchpointList.sort(function (a, b) {
      if (a.active === b.active) {
        return 0;
      }
      return a.active ? -1 : 1;
    });
  }


  onClickTouchpointNameButton(i: number) {
    if (this.touchpointList) {
      this.touchpointList[i]["active"] = !this.touchpointList[i]["active"];
      if (!this.touchpointList[i].active) {
        this.touchpointList[i].templateValue = null;
      }
    }
    this.checkForTouchpointPriority();

  }

  onClickLayoutBtn(i: number) {
    this.currentTouchpointIndex = i;

    let schema = this.fieldModel.layoutDefaultSchema;

    if (!schema && this.templateSelected) {
      schema = this.templateSelected.templateSchema;
    }

    this.currentSchema = schema;
    const existingValue = this.touchpointList[i].templateValue;

    this.model = existingValue ? cloneDeep(existingValue) : {};
    this.show.modalLayoutTouchpoint = true;
  }


  onClickDeleteLayoutBtn(touchpointIndex: number) {
    const confirmationMessage = this.translate.instant('challenge.confirm_delete_touchpoint_layout');
    const header = this.translate.instant('campaign.confirm_delete');
    this.srvConfirmation.confirm({
      message: confirmationMessage,
      header: header,
      accept: () => {
        this.deleteTouchpointLayout(touchpointIndex);
      },
      reject: () => {

      }
    })
  }

  private deleteTouchpointLayout(touchpointIndex: number) {
    console.log(this.touchpointList);
    const currentTp = this.touchpointList[touchpointIndex];

    if (!currentTp) return;

    currentTp.templateValue = null;
    //currentTp.active = false;

    this.srvNotify.add({
      severity: 'info',
      summary: this.translate.instant('common.info'),
      detail: this.translate.instant('challenge.layout_reset_success') // "Layout reset successfully"
    });
  };

  breadcrumbClicked(breadcrumb: BreadCrumbModel) {
    if (breadcrumb.routerLink) {
      this.router.navigate([breadcrumb.routerLink]);
    } else {
      console.log("Nessuna route implementata");
    }
  }

  onAcceptanceFlagChange(active: boolean) {
    if (!active) {
      this.fieldModel.acceptance_cluster = null;   // reset valore
    }
  }


  private initTemplate(templateResponse: any[]): void {
    // Guard clause per casi edge
    if (!templateResponse || templateResponse.length === 0 || !this.listAccumulator) {
      this.selectedTemplate = [];
      return;
    }

    // Set per tracciare gli ID già aggiunti
    const addedTemplateIds = new Set<number>();
    this.selectedTemplate = [];

    // Itera sugli accumulatori dalla response
    for (let i = 0; i < templateResponse.length; i++) {
      const templateId = templateResponse[i].templateId;

      // Verifica che acmId esista e abbia un id valido
      if (!templateId || !templateId.id) {
        continue;
      }

      // Salta se questo ID è già stato aggiunto
      if (addedTemplateIds.has(templateId.id)) {
        continue;
      }

      // Cerca l'accumulatore corrispondente nella lista
      const foundTemplate = this.listAccumulator.find(
        acc => acc && acc.id === templateId.id
      );

      // Se trovato, aggiungilo e marca l'ID come usato
      if (foundTemplate) {
        this.selectedTemplate.push(foundTemplate);
        addedTemplateIds.add(templateId.id);
      }
    }

    console.log('Selected ACMS (unique):', this.selectedTemplate);
  }

  onClickLayoutDefault() {
    const schema = this.templateSelected ? this.templateSelected.templateSchema : this.fieldModel.layoutDefaultSchema;

    this.currentSchema = schema;

    const defaultValue = this.fieldModel.layoutDefaultValue;
    this.model = defaultValue ? cloneDeep(defaultValue) : {};

    this.show.modalLayoutDefault = true;
  }

  saveLayoutDefault(formValues: any) {
    this.fieldModel.layoutDefaultValue = formValues;
    this.show.modalLayoutDefault = false;
  }
  /*
    onChange(updatedData: any) {
      // Aggiorna i dati locali
      this.formData = updatedData;
      this.validateForm(); // Valida il form
    }

    private validateForm() {
      // Logica di validazione personalizzata
      if (this.formData.requiredField && !this.formData.requiredField.value) {
        console.warn('Campo obbligatorio mancante');
      }
    }
  */
  closeLayoutDefaultForm() {
    this.show.modalLayoutDefault = false;
  }

  closeLayoutTouchpointForm() {
    this.show.modalLayoutTouchpoint = false;
  }

  submitForm(layoutType: string) {
    if (!this.validateFormLayout(this.model)) {
      console.log("il form non è valido")
      return;
    }
    const i = this.currentTouchpointIndex;

    const sanitizedData = this.sanitizeModelForSave(this.model);
    console.log('Dati sanitizzati:', sanitizedData);

    // Se vuoi anche rimuovere oggetti vuoti come "form": {}
    const finalData = this.removeEmptyNestedObjects(sanitizedData);
    console.log('Dati finali:', finalData);


    if (layoutType === 'touchpoint') {
      this.touchpointList[i].templateValue = finalData;

      this.closeLayoutTouchpointForm();

    } else if (layoutType === 'default') {
      this.fieldModel.layoutDefaultValue = finalData;
      this.closeLayoutDefaultForm();
    }
    //nel caso di validazione errata , viene sbiancata
    this.challengeTouchpointValid =
      (this.fieldModel.layoutDefaultValue != null) ||
      this.touchpointList.some((tp) => tp.active && tp.templateValue != null);
  }
  private validateFormLayout(formValue: any) {
    let formIsValid = true;
    if (this.fieldModel.layoutDefaultSchema != undefined && this.fieldModel.layoutDefaultSchema.required != undefined) {
      this.fieldModel.layoutDefaultSchema.required.forEach(requiredField => {
        if (!formValue[requiredField]) {
          formIsValid = false;
        }
      });
    }
    return formIsValid;
  }

  onTemplateChange(selected: OptionDropdown) {
    if (this.templateSelected) {
      this.form = new FormGroup({});
      this.model = {};

      const someTouchpointActive = this.touchpointList.some(tp => tp.active);
      if (someTouchpointActive) {
        const newSelection = selected;
        const previousOption = this.templateDropdownList.find(opt => opt.value === this.templateSelected.id);

        setTimeout(() => {
          this.fieldModel.template = previousOption;
        })

        this.srvConfirmation.confirm({
          message: this.translate.instant("common.warning"),
          accept: () => {
            this.fieldModel.template = newSelection;
            this.clearTouchpoint(selected);
          },
          reject: () => {
            console.log("Reverting to: ", this.previousTemplate);
          },
          acceptLabel: "Sì",
          rejectLabel: "Annulla",
        });
      } else {
        this.clearTouchpoint(selected);
      }
    } else {
      this.clearTouchpoint(selected)
    }

  }

  clearTouchpoint(selected: OptionDropdown) {
    this.templateSelected = this.templateList.find(t => t.id === selected.value);

    if (this.templateSelected && this.templateSelected.templateSchema) {
      this.show.modalTemplate = true;
      this.fieldModel.layoutDefaultSchema = this.templateSelected.templateSchema;
      this.fieldModel.layoutDefaultValue = null;

      this.touchpointList.forEach(tp => {
        tp.templateValue = null;
        tp.active = false;
      });
    }
  }

  onPushNotifyChange() {
    this.fieldModel.pushNotifyText = ''
    this.fieldModel.dayBeforeNotifyPush = ''
    this.fieldModel.notifyPushHour = null
  }
  private startOfDay(d: Date): Date {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
  }

  private endOfDay(d: Date): Date {
    const x = new Date(d);
    x.setHours(23, 59, 59, 999);
    return x;
  }



  private filterClusters(): void {
    var sfidaStart = this.fieldModel.dateStart
      ? this.startOfDay(this.fieldModel.dateStart)
      : null;

    var sfidaEnd = this.fieldModel.dateEnd
      ? this.endOfDay(this.fieldModel.dateEnd)
      : null;

    // se non ho data start → nessun filtro
    if (!sfidaStart) {
      this.clusterList = this.buildClusterDisplayList(this.originalClusters);
      this.fieldModel.acceptance_cluster = null;
      return;
    }

    var filteredRaw = [];

    for (var i = 0; i < this.originalClusters.length; i++) {
      var c = this.originalClusters[i];

      var clusterStart = c.startDate
        ? this.startOfDay(c.startDate)
        : null;

      var clusterEnd = c.endDate
        ? this.endOfDay(c.endDate)
        : null;

      // cluster senza start → lo scarto
      if (!clusterStart) continue;

      var startOk = clusterStart <= sfidaStart;

      // CASO A: sfida ha fine
      if (sfidaEnd) {
        if (startOk && clusterEnd && clusterEnd >= sfidaEnd) {
          filteredRaw.push(c);
        }
      }
      // CASO B: sfida SENZA fine
      else {
        if (startOk && clusterEnd && clusterEnd >= sfidaStart) {
          filteredRaw.push(c);
        }
      }
    }

    this.clusterList = this.buildClusterDisplayList(filteredRaw);
    this.fieldModel.acceptance_cluster = null;
  }

  private lastDatesKey: string = null;

  onDateChange(): void {
    this.filterClusters();
    var key = (this.fieldModel.dateStart ? new Date(this.fieldModel.dateStart).getTime() : '')
      + '|' + (this.fieldModel.dateEnd ? new Date(this.fieldModel.dateEnd).getTime() : '');
    var changed = this.lastDatesKey !== null && this.lastDatesKey !== key;
    this.lastDatesKey = key;
    if (changed && this.selectedDistributionList) {
      this.srvNotify.add({
        severity: 'warn',
        summary: this.translate.instant('common.warning'),
        detail: this.translate.instant('challenge.dates_changed_list_warning')
      });
    }
  }

  //ripulisco json
  private sanitizeModelForSave(model: any): any {
    return this.removeEmptyValues(model);
  }

  private removeEmptyValues(obj: any): any {
    if (obj === null || obj === undefined) {
      return undefined;
    }

    if (typeof obj !== 'object') {
      return obj === '' ? undefined : obj;
    }

    if (Array.isArray(obj)) {
      const filtered = obj
        .map(item => this.removeEmptyValues(item))
        .filter(item => item !== undefined);
      return filtered.length > 0 ? filtered : undefined;
    }

    const cleaned: any = {};
    let hasValidProperties = false;
    for (const key of Object.keys(obj)) {
      const value = obj[key];
      const cleanedValue = this.removeEmptyValues(value);
      if (cleanedValue !== undefined) {
        cleaned[key] = cleanedValue;
        hasValidProperties = true;
      }
    }

    return hasValidProperties ? cleaned : undefined;
  }


  private removeEmptyNestedObjects(obj: any): any {
    const result = JSON.parse(JSON.stringify(obj));

    // Rimuovi oggetti vuoti ricorsivamente
    const clean = (current: any): any => {
      if (typeof current !== 'object' || current === null) {
        return current;
      }

      if (Array.isArray(current)) {
        return current.map(item => clean(item)).filter(item => item !== undefined);
      }

      const cleanedObj: any = {};
      let hasProperties = false;

      for (const key in current) {
        if (current.hasOwnProperty(key)) {
          const value = clean(current[key]);
          if (value !== undefined) {
            cleanedObj[key] = value;
            hasProperties = true;
          }
        }
      }

      return hasProperties ? cleanedObj : undefined;
    };

    return clean(result);
  }
}





// WEBPACK FOOTER //
// ./src/app/views/challenge/challenge-creation/challenge-creation.component.ts